import { render } from "./NewFilter.vue?vue&type=template&id=791d7795&scoped=true"
import script from "./NewFilter.vue?vue&type=script&lang=js"
export * from "./NewFilter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-791d7795"

export default script